import { classNames } from 'primereact/utils';
import React, { FC, useState, useRef, useMemo } from 'react';
import { If } from '../If/If';

import styles from './sidebar.module.scss';
import {TUserCompanyConfigItem} from "../../@types/global";
import useOutsideClick from "../../hooks/useOutsideClick";
import {useNavigate} from "react-router-dom";
import oaiLogo from '../../assets/icons/companyLogos/open-ai.png';
import wstLogo from '../../assets/icons/companyLogos/westaway.png';
import vglLogo from '../../assets/icons/companyLogos/virgil.png';
import evrLogo from '../../assets/icons/companyLogos/every.jpg';
import dolLogo from '../../assets/icons/companyLogos/dayonelaw.png';
import graLogo from '../../assets/icons/companyLogos/grayver-law-logo.png';
import axonLogo from  '../../assets/icons/companyLogos/axon-logo.png'
import gundLogo from '../../assets/icons/companyLogos/gunderson_dettmer_logo.png';
import ildLogo from '../../assets/icons/companyLogos/Inceptiv-law-icon.png';

const companyLogos: Record<string, string> = {
  OAI: oaiLogo,
  WST: wstLogo,
  VGL: vglLogo,
  EVR: evrLogo,
  DOL: dolLogo,
  GRL: graLogo,
  GDR: gundLogo,
  XON: axonLogo,
  ILD:ildLogo
};

interface IUserSectionProps {
  isOpened: boolean;
  roleLabel: string;
  userName: string;
  companies: TUserCompanyConfigItem[];
  selectedCompanyId: number;
  updateCompanyInfo: React.Dispatch<React.SetStateAction<TUserCompanyConfigItem>>;
  companyId: number;
}

const UserSection: FC<IUserSectionProps> = ({
  isOpened,
  roleLabel = '',
  userName = '',
  companies,
  selectedCompanyId,
  updateCompanyInfo,
  companyId,
}) => {

  const targetRef = useRef(null); 
  const navigate = useNavigate();

  const [toggled, toggle] = useState<boolean>(false);

const { isLogoAvailable, companyLogo } = useMemo(() => {

  const matchedCompany = companies.find(
    (c) => c.companyId === companyId && c.icon
  );

  if (matchedCompany) {
    return {
      companyLogo: matchedCompany.icon,
      isLogoAvailable: true,
    };
  }

  return {
    companyLogo: undefined,
    isLogoAvailable: false,
  };

}, [companyId, companies, companyLogos]);


  useOutsideClick(targetRef, () => {
    toggle(false);
  });

  const onSwitchCompany = (companyConfig: TUserCompanyConfigItem) => {
    sessionStorage.setItem('selectedCompanyId', `${companyConfig?.companyId}`);
    updateCompanyInfo(companyConfig);
    toggle(false);
    navigate('/');
  }

  return (
    <div className={classNames(styles.userSection, {
      [styles.isClosed]: !isOpened
    })} ref={targetRef}>
      <div className={styles.userInfo} onClick={() => toggle(true)}>
        {
          isLogoAvailable ? (
              <div className={styles.userCustomLogoHolder}>
                <img src={String(companyLogo)} />
              </div>
          ) : (
              <div className={styles.userLogoHolder}>{userName.charAt(0)}</div>
          )
        }
        <If condition={isOpened}>
          <>
          <div
              className={classNames(
                styles.nameHolder,
                styles.delayedSmoothAppear,
              )}
            >
              <p className={styles.nameTxt}>{userName}</p>
              <p className={styles.positionTxt}>{roleLabel}</p>
            </div>
            <div className={styles.arrowGroup}>
              <i className="bi bi-caret-up-fill"></i>
              <i className="bi bi-caret-down-fill"></i>
            </div>
          </>
        </If>
      </div>
      {
          isOpened && toggled && (
              <div className={styles.companiesDropdown}>
                <div className={styles.listWrapper}>
                  {
                    companies.map((companyConfig: TUserCompanyConfigItem, index) => {
                      const {companyId, companyName} = companyConfig;
                      return (
                          <div onClick={() => onSwitchCompany(companyConfig)} key={index} className={classNames(styles.listItem, {
                            [styles.selected]: companyId === selectedCompanyId,
                          })}>
                            {companyName}
                          </div>
                      )
                    })
                  }
                </div>
              </div>
          )
      }
    </div>
  );
};

export default UserSection;
